exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-tel-input .form-control {\n  width: 100%;\n  border: 1px solid #ced4da;\n}", ""]);

// exports
